// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__KvTR0","isBeta":"Badge_isBeta__ib_FR"};